/**
 * Support widget — the messages two windows use to talk to each other.
 *
 * Every string here has to be spelled identically by a Django page and by the React
 * app inside its iframe. A typo on either side is silent: nothing throws, the listener
 * simply never matches, and the sender waits out its timeout and acts alone. They were
 * hand-written in four separate files before this.
 *
 * Both protocols are request/answer and both are opt-in, so neither side can hang the
 * other — see `CROSS_FRAME_ANSWER_TIMEOUT_MS`.
 */

// ---- The job form asking its page to open the page's support widget (#5622) ----
// Sent by fe-react's `requestPageSupportSheet`, answered by douleutaras'
// `lazy-support-widget-loader`.
export const SUPPORT_OPEN_REQUEST_MESSAGE = "supportWidget:openRequest"
export const SUPPORT_OPENED_MESSAGE = "supportWidget:opened"
export const SUPPORT_UNAVAILABLE_MESSAGE = "supportWidget:unavailable"

// ---- The page asking the job form whether it may close (#5622) ----
// The × lives on the Django page but the form is allowed to intercept it, which is how
// the exit-intent panel gets a say. Sent by douleutaras' `lazy-form-loader.base`,
// answered by fe-react's `PostJobIframe`.
/** Broadcast by the form when it opens, for analytics and the page's own bookkeeping. */
export const JOB_MODAL_OPEN_MESSAGE = "jobModal:open"
export const JOB_MODAL_CLOSE_MESSAGE = "jobModal:close"
export const JOB_MODAL_CLOSE_REQUEST_MESSAGE = "jobModal:closeRequest"
export const JOB_MODAL_CLOSE_REQUEST_HANDLED_MESSAGE = "jobModal:closeRequestHandled"
export const JOB_MODAL_ACCEPTS_CLOSE_REQUESTS_MESSAGE = "jobModal:acceptsCloseRequests"

/**
 * How long either side waits for the other's answer before acting on its own.
 *
 * One round trip between two same-origin windows, so this is a main-thread budget
 * rather than a network one: long enough to survive a busy frame, short enough that a
 * window which will never answer does not leave the customer looking at a control that
 * did nothing. Both directions use the same number — they are the same round trip.
 */
export const CROSS_FRAME_ANSWER_TIMEOUT_MS = 500
